/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars, mj_make_filename, str_trim } from './util.js';
import { postToBackend } from './fetch-util.js';
import { mj } from './page-mj.js';
import { mjt } from './i18ntexts.js';

import { MPlugins } from './plugins.js';

import { MDMeta } from './meta-data.js';
import { MDMedia } from './media-data.js';
import { MDTrees } from './tree-data.js';
import { MVMediaMetadata } from './media-data-view.js';

import { confirm_box } from './page-modal.js';
import { showInfoToast, showWarningToast } from './snackbar.js';


export function register_std_plugins() {
	/**
	 * combine image width, height & type into one field
	 */
	MPlugins.register( [], 'std-view-img-dims-and-type', {
		type: 'MediaMetaViewData',
		meta_ids: [ 200, 201, 226 ],
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo, context ) {
			if( meta_id==201 ) {
				// NOTE: always change the label (important for diff view)
				tr.children('th').text(mjt('meta-def-image-width-height-type','!'));
				// display combined info in this field
				const m = dtinfo.meta;
				const img_width = m[200] && m[200][0] ? m[200][0] : 0;
				const img_height = m[201] && m[201][0] ? m[201][0] : 0;
				if( img_width>0 || img_height>0 ) {
					const img_type = m[226] && m[226][0] ? m[226][0] : 'RASTER';
					let img_dims_html = MVMediaMetadata.getInteractiveDisplayDataItem(img_width,200)+' x '+MVMediaMetadata.getInteractiveDisplayDataItem(img_height,201);
					if( img_type=='VECTOR' ) img_dims_html += ' (<span class="link" onclick="MVMediaPage.start_search(\'VECTOR\',226)">'+mjt('image-type-scalable')+'</span>)';
					tr.removeClass('md-hide').addClass('md-avl').children('td').html(MVMediaMetadata.wrapWithMetaDataHolder([200,201],img_dims_html));
				}
			} else {
				// hide the other fields
				tr.removeClass('md-avl').addClass('md-hide');
			}
		},
	} );

	/**
	 * combine different data for custom previews into one field
	 */
	MPlugins.register( [], 'std-view-custom-previews', {
		type: 'MediaMetaViewData',
		meta_ids: [ 10, 11, 12 ],
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo, context ) {
			if( meta_id==10 ) {
				// NOTE: always change the label (important for diff view)
				tr.children('th').text(mjt('meta-def-custom-preview','!'));
				// display combined info in this field
				const m = dtinfo.meta;
				const cp_width = m[10] && m[10][0] ? m[10][0] : 0;
				const cp_height = m[11] && m[11][0] ? m[11][0] : 0;
				const cp_uploaded = m[12] && m[12][0] ? m[12][0] : '';
				const cp_defined = cp_width>0;
				const cp_info_html = cp_defined ? (MDMeta.getDisplayDataItem(cp_width,10)+' x '+MDMeta.getDisplayDataItem(cp_height,11)+' ('+MDMeta.getDisplayDataItem(cp_uploaded,12)+')') : mjt('custom-preview-none');
				const can_edit = mj.role_manager && dtinfo.r_edit;
				tr.removeClass('md-hide').addClass('md-avl').find('>td').html(MVMediaMetadata.wrapWithMetaDataHolder([10,11,12],cp_info_html));
				if( can_edit ) tr.attr('data-edit','1');
			} else {
				// hide the other fields
				tr.removeClass('md-avl').addClass('md-hide');
			}
		},
	} );

	/**
	 * - add extended view to "custom preview" field in edit mode
	 */
	MPlugins.register( [], 'std-edit-custom-previews', function() {
		return {
			type: 'MediaMetaEditView',
			meta_ids: [ 10 ],
			setupEditView: function( media_id, meta_id, btns_div, wdgs_div, val_arr, dtinfo, close_view, update_canvas ) {
				const self_tr_hack = wdgs_div.closest('tr');
				if( btns_div ) btns_div.empty();

				let html_tmp = '';
				html_tmp += '<span id="cpu_upload_swf"></span>';
				html_tmp += '<span class="remove-custom-preview" tabindex="0"><span class="remove-custom-preview-icon"></span>'+mjt('custom-preview-upload-remove')+'</span>';
				html_tmp += '<span id="cpu_upload_queue"></span>';
				wdgs_div.html(html_tmp);
				let data=dtinfo.meta;
				let cp_width=data[10] && data[10][0] ? data[10][0] : 0;
				let cp_height=data[11] && data[11][0] ? data[11][0] : 0;
				let cp_defined=cp_width>0;

				const cp_upload_close = function() {
					if( close_view ) close_view();
					// update state..
					data = dtinfo.meta;
					cp_width = data[10] && data[10][0] ? data[10][0] : 0;
					cp_height = data[11] && data[11][0] ? data[11][0] : 0;
					cp_defined = cp_width>0;
					const cp_uploaded = data[12] && data[12][0] ? data[12][0] : '';
					const cp_info_html = cp_defined ? (MDMeta.getDisplayDataItem(cp_width,10)+' x '+MDMeta.getDisplayDataItem(cp_height,11)+' ('+MDMeta.getDisplayDataItem(cp_uploaded,12)+')') : mjt('custom-preview-none');
					self_tr_hack.children('td')
						.find('.batch-process-item').hide().end()
						.find('.data-holder').html(cp_info_html+'&nbsp;');
					// update canvas
					if( update_canvas ) update_canvas();
					// re-create thumbnails in all views
					$(document).triggerHandler('mjsrecreatethumbnails',[media_id,data]);
				};

				if( cp_defined ) {
					wdgs_div.find('.remove-custom-preview').click( function() {
						confirm_box( mjt('custom-preview-upload-remove-title'), mjt('custom-preview-upload-remove-msg'), function() {
							postToBackend('json/media/manage-cpremove', 'media_id='+encodeURIComponent(media_id)+'&cp_id=0', function(j) {
								if( j.error ) {
									showWarningToast('remove failed ('+j.error+'; '+j.info+')');
								} else {
									showInfoToast(mjt('custom-preview-upload-removed'));
									if( j.meta && j.meta[media_id] ) dtinfo.meta = j.meta[media_id] || {'-1':[0]};
									MDMedia.triggerMetaChanged( [media_id], {meta:j.meta}, {10:10,11:11,12:12}, {} );
								}
								cp_upload_close();
							});
						});
					});
				} else {
					wdgs_div.find('.remove-custom-preview').hide();
					$('#cpu_upload_swf',wdgs_div).mjUploadWidget( {
						type: 'single',
						upload_url: 'json/media/manage-cpupload',
						post_params: { media_id:media_id, cp_id:0 },
						file_types: mj.upload_image_file_types_filter,
						file_types_description: mjt('image-file-types'),
						button_text: mjt('custom-preview-upload-button'),
						start: function( file ) {
							$('#cpu_upload_queue').empty().show();
						},
						progress: function( file, bytesLoaded, bytesTotal, percent ) {
							$('#cpu_upload_queue').text(''+percent+'%');
						},
						success: function( file, j ) {
							showInfoToast(mjt('custom-preview-upload-success'));
							if( j.meta && j.meta[media_id] ) dtinfo.meta = j.meta[media_id] || {'-1':[0]};
							MDMedia.triggerMetaChanged( [media_id], {meta:j.meta}, {10:10,11:11,12:12}, {} );
						},
						fail: function( file ) {
							setTimeout( function() {
								// reload widget (the upload may have finished on server, even if aborted on client...)
								// ???
							}, 200 );
						},
						complete: function( file ) {
							cp_upload_close();
							return false;
						},
					} ).find('.muw-button').focus();

					wdgs_div.on( 'remove', function( evt ) {
						$('#cpu_upload_swf',wdgs_div).mjUploadWidget('destroy');
						// $('#cpu_upload_swf',wdgs_div).closest('form.edit-item-form').remove();
					} );
				}
			},
		};
	} );


	/**
	 * show "photoshop-clip-path-index" as a highlighted item in list of clip path names (photoshop-path-names)
	 */
	MPlugins.register( [], 'std-view-photoshop-clip-path', {
		type: 'MediaMetaViewData',
		meta_ids: [ 233, 234 ],
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo, context ) {
			if( meta_id==233 ) {
				// NOTE: always change the label (important for diff view)
				tr.children('th').text(mjt('meta-def-photoshop-path-names-and-clip-path','!'));
				// display combined info in this field
				const m = dtinfo.meta;
				const img_clip_path_idx = m[234] && m[234][0] ? m[234][0] : -1;
				if( img_clip_path_idx>=0 ) {
					const data_elem = tr.find('>td>.data-holder>.data[data-listpos='+img_clip_path_idx+']');
					if( data_elem.length ) data_elem.addClass('emph').append(' <span class="link" onclick="MVMediaPage.start_search(\'?*\',234)">'+mjt('meta-def-photoshop-path-is-clip-path')+'</span>');
				} else {
					tr.find('>td>.data-holder').append('<br><span class="data other"><span class="link" onclick="MVMediaPage.start_search(\'\',234)">'+mjt('meta-def-photoshop-path-no-clip-path')+'</span></span>');
				}
			} else {
				// hide the other fields
				tr.removeClass('md-avl').addClass('md-hide');
			}
		},
	} );

	/**
	 * restore suffix on "filename" (1) when updating
	 */
	MPlugins.register( [], 'std-save-1', {
		type: 'MediaMetaSaveData',
		meta_ids: [ 1 ],
		beforeSaveMetaData: function( media_ids, meta_id, data, cur_data ) {
			if( data.meta && data.meta[1] && data.meta[1].length ) {
				let new_fn = data.meta[1][0];
				const dot_pos = new_fn.lastIndexOf('.');
				const old_sfx = cur_data.meta && cur_data.meta[6] && cur_data.meta[6].length ? cur_data.meta[6][0] : null;
				let new_sfx;
				if( old_sfx !== null ) {
					if( dot_pos==-1 ) {
						// filename suffix is missing ...
						// -> append the old suffix
						new_fn = new_fn + '.' + old_sfx;
					} else {
						// filename is OK
						// - compare suffix to old one ...
						new_sfx = new_fn.substr(dot_pos+1).toLowerCase();
						if( new_sfx != old_sfx.toLowerCase() ) {
							// filename suffix is DIFFERENT ...
							// if( false ) {
							// 	// -> append the old suffix (so it will have both old and new suffix appended)
							// 	new_fn = new_fn + '.' + old_sfx;
							// } else {
							// -> restore the old suffix
							new_fn = str_trim( new_fn.substr(0,dot_pos) ) + '.' + old_sfx;
							// }
						}
					}
				}
				// make safe filename
				new_fn = mj_make_filename(new_fn);
				// store
				data.meta[1][0] = new_fn;
			}
		},
	} );

	/**
	 * add a/v-related status info to thumbnail views
	 */
	MPlugins.register( [], 'std-av-thumb-view-1', function() {
		return {
			type: 'MediaThumbnailView',
			meta_ids: [ 802 ], // 802=avcontainer-duration
			bindStatusChanged: function( view_mode, cb ) {
			},
			queryMediaViewStatus: function( view_mode, media_ids, meta, trigger_status_change ) {
			},
			resetViewNode: function( view_mode, node, media_id ) {
				if( view_mode==='link' ) return; // ignored here
				node.removeClass('av-playable');
			},
			updateViewNode: function( view_mode, node, media_id, meta ) {
				// view_mode is one of: 'lightbox', 'result', 'mj-thumb-box', 'link'
				if( view_mode==='link' ) return; // ignored here
				const av_playable = !!(meta[802]&&meta[802][0]);
				if( av_playable ) {
					if( node.find('.media-overlay-1-av-playable').length===0 ) {
						const ovl_html = '<div class="media-overlay-1 media-overlay-1-av-playable keep"></div>';
						if( view_mode==='result' ) node.find('.thumbnail').append(ovl_html);
						else if( view_mode==='lightbox' ) node.prepend(ovl_html);
						else if( view_mode==='mj-thumb-box' ) node.append(ovl_html);
					}
					node.addClass('av-playable');
				} else {
					node.removeClass('av-playable');
				}
			},
			initViewNodesRoot: function( view_mode, root_node, on_action ) {
				//if( view_mode==='result' || view_mode==='lightbox' || view_mode==='mj-thumb-box' ) {
				//}
			},
		};
	} );



	function _getVersionCommentItemIdsType( dispVal, startPos ) {
		const colonPos = dispVal.indexOf(':',startPos);
		if( colonPos!==-1 ) {
			const strBeforeColon = dispVal.substr(startPos,colonPos-startPos).trim();
			const scPos = dispVal.indexOf(';',colonPos);
			const strAfterColon = dispVal.substr(colonPos+1,scPos===-1?undefined:(scPos-(colonPos+1))).trim();
			let getItemIdDisplayName = null;
			if( strBeforeColon==='updated meta data' || strBeforeColon==='added to meta data' ) {
				getItemIdDisplayName = (numericId,plain_text,make_link) => _getMetaIdDisplayName(numericId,plain_text,make_link);
			} else if( strBeforeColon==='assigned categories' ) {
				getItemIdDisplayName = (numericId,plain_text,make_link) => _getCategoryIdDisplayName(numericId,plain_text,make_link);
			}
			if( getItemIdDisplayName!==null ) {
				return {
					getItemIdDisplayName,
					startPos,
					endPos: scPos===-1 ? dispVal.length-1 : scPos,
					strBeforeColon,
					strAfterColon,
				};
			}
		}
		return null;
	}

	function _getVersionCommentItemIdsTypes( dispVal ) {
		let itemsIdTypeArr = [];
		let itemsIdType;
		for( let startPos=0; startPos<dispVal.length; startPos=itemsIdType.endPos+1 ) {
			if( (itemsIdType=_getVersionCommentItemIdsType(dispVal,startPos))===null ) break;
			itemsIdTypeArr.push(itemsIdType);
		}
		return itemsIdTypeArr;
	}

	function _getMetaIdDisplayName( metaIdStr, plain_text, make_link ) {
		const metaDef = MDMeta.getDefinition(metaIdStr);
		const metaDefDispName = metaDef.lname || metaDef.name || metaIdStr;
		let resStr = metaDefDispName+' (meta_id='+metaIdStr+')';
		if( !plain_text && make_link && mj.role_administrator ) {
			const url = mj.uwn+'/administration/metadata#meta_id='+encodeURIComponent(metaIdStr);
			resStr = '<a href="'+htmlspecialchars(url,true,true)+'" target="_blank">'+resStr+'</a>';
		}
		return resStr;
	}

	function _getCategoryIdDisplayName( categoryIdStr, plain_text, make_link ) {
		const treeId = MDTrees.getTreeIdFromCategoryId(categoryIdStr);
		const categoryNode = MDTrees.getCategoryNode(treeId,categoryIdStr);
		const categoryNodeDispName = categoryNode===null ? categoryIdStr : ( categoryNode.name || categoryIdStr );
		let resStr = categoryNodeDispName+' (cat_id='+categoryIdStr+')';
		// if( !plain_text && make_link && mj.role_administrator ) {
		// }
		return resStr;
	}


	/**
	 * enhanced version comment
	 *
	 * NOTE: as of manja 4.45.0 (2023-09-15), the following standard version comments are in use:
	 *		cloned
	 *		uploaded
	 *		updated xmp
	 *		annotations modified
	 *		removed custom preview
	 *		updated custom preview
	 *		deleted
	 *		save through temp file (MediaFilenameTracking)
	 *		updated meta data: <meta_id>[, <meta_id> ...]
	 *		added to meta data: <meta_id>[, <meta_id> ...]
	 *		assigned categories: <cat_id>[, <cat_id> ...]

	 */
	MPlugins.register( [], 'std-data-version-comment', {
		type: 'MediaMetaDisplayData',
		meta_ids: [ 14 ],

		prepareDisplayData: function( meta_def, data_val ) {
			// console.log({w:'prepareDisplayData',meta_def,data_arr});
			const itemsIdTypeArr = _getVersionCommentItemIdsTypes(data_val);
			if( itemsIdTypeArr.length===null ) return null;
			return {
				itemsIdTypeArr,
				getDisplayValueFragment( search_val, disp_val, data_val_offs, context, plain_text, make_link ) {
					// console.log({w:'getDisplayValueFragment',search_val,disp_val,data_val_offs,context,plain_text,make_link});
					const numericVal = parseInt(disp_val,10);
					if( !isNaN(numericVal) ) {
						for( const itemsIdType of context.itemsIdTypeArr ) {
							// if( data_val_offs >= itemsIdType.startPos && data_val_offs+disp_val.length <= itemsIdType.endPos ) {
							if( data_val_offs >= itemsIdType.startPos && data_val_offs<=itemsIdType.endPos ) {
								return [numericVal,itemsIdType.getItemIdDisplayName(numericVal,plain_text,make_link)];
							}
						}
					}
					return [null,disp_val];
				},
			};
		},

		getDisplayDataItem: function( meta_def, data_val, plain_text, make_link ) {
			// console.log({w:'updateDisplayData',meta_def,data_val,plain_text,make_link});
			const itemsIdTypeArr = _getVersionCommentItemIdsTypes(data_val);
			// console.log({w:'updateDisplayData',meta_def,data_arr,plain_text,i,data_arr_i:data_arr[i],itemsIdTypeArr});
			if( itemsIdTypeArr.length ) {
				let newDataVal = '';
				for( const itemsIdType of itemsIdTypeArr ) {
					const idList = itemsIdType.strAfterColon.split(/,\s*/);
					const resStrList = idList.map( (itemIdStr) => itemsIdType.getItemIdDisplayName(itemIdStr,plain_text,make_link) );
					if( newDataVal.length!==0 ) newDataVal += plain_text ? ';\n' : ';<br>';
					newDataVal += itemsIdType.strBeforeColon+': '+resStrList.join(', ');
				}
				return newDataVal;
			}
			return data_val;
		},
	} );


	/** dummy plugin
	MPlugins.register( [$,mj], 'std-view-dummy-hide-some-stuff', {
		type: 'MediaMetaViewData',
		meta_ids: [ 10,11,12,13,14,15,16,17,18,19,20,   233,234,   200,201,226, 101,114 ],
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo, context ) {
			// hide all rows
			tr.removeClass('md-avl').addClass('md-hide');
		}
	} );
	***/
}

